<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="页面名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入页面名称" v-trim/>
      </el-form-item>
      <el-form-item label="页面地址" prop="pageAddr">
        <el-input v-model="form.pageAddr" placeholder="请输入页面地址（/default.html 表示网站默认配置项）" v-trim/>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入标题" v-trim/>
      </el-form-item>
      <el-form-item label="关键字" prop="keywords">
        <el-input type="textarea" v-model="form.keywords" placeholder="请输入关键字" v-trim/>
      </el-form-item>
      <el-form-item label="作者信息" prop="author">
        <el-input v-model="form.author" placeholder="请输入作者信息" v-trim/>
      </el-form-item>
      <el-form-item label="排序码(升序)" prop="sortnum">
        <el-input v-model="form.sortnum" type="number" placeholder="请输入排序码" v-trim/>
      </el-form-item>
      <el-form-item label="描述" prop="remark">
        <el-input v-model="form.remark" type="textarea" placeholder="请输入描述" v-trim/>
      </el-form-item>
      <el-form-item label="图片alt" prop="imgalt">
        <el-input v-model="form.imgalt" placeholder="请输入图片alt" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaSeoWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        remark: '',
        name: '',
        title: '',
        keywords: '',
        author: '',
        icon: '',
        pageAddr: '',
        sortnum: '',
        imgalt: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/seo',
      'field.id': 'id'
    })
  }
}
</script>
